import React from 'react'
import { PieChart, Pie, Tooltip, Cell } from 'recharts'
import { toCamelCase } from '../../../utils/toCamelCase'
import styled from 'styled-components'

const InsideNumber = styled.span`
  font-size: ${({ theme }) => theme.fontSize.s35};
  position: absolute;
  left: 0;
  right: 0;
  top: 40px;
  margin: auto;
  width: fit-content;
`

const StyledTooltip = styled.div`
  background-color: rgb(0, 0, 0, 0.8);
  transition: opacity 0.3s ease;
`
const TooltipContent = styled.div`
  color: white;
  font-size: ${({ theme }) => theme.fontSize.s14};
`

type Props = {
  data: any
  cellColors: any
}

const PieChartComponent: React.FC<Props> = ({ data, cellColors }) => {
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      return (
        <StyledTooltip className="custom-tooltip">
          <TooltipContent className="label">{`${payload[0].name} : ${payload[0].value}`}</TooltipContent>
        </StyledTooltip>
      )
    }

    return null
  }

  return (
    <div style={{ position: 'relative' }}>
      <InsideNumber>
        {data.reduce(
          (accumulator, currentValue) => accumulator + currentValue.value,
          0
        )}
      </InsideNumber>
      <PieChart style={{ margin: '20px 10px' }} width={100} height={100}>
        <Pie
          stroke="none"
          data={data}
          innerRadius={45}
          outerRadius={50}
          fill="#8884d8"
          paddingAngle={4}
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={cellColors[toCamelCase(entry.name)]}
            />
          ))}
        </Pie>
        <Tooltip content={<CustomTooltip />} />
      </PieChart>
    </div>
  )
}

export default PieChartComponent
